import { fromSpecific, scope, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { AnyExpressionSpecific, MustacheNode } from '../Mustache'
import type { ElementPlugin } from './plugin'
import type {
  AnyTypedNode,
  TypedSpecific,
  TypedSpecificLike
} from '@rehaje/core'
import type { RecursionType } from '@rehaje/shared'

export type AnyElementNode =
  | (AnyTypedNode & { type: `Element.${string}` })
  | MustacheNode

export type AnyElementSpecific =
  | AnyExpressionSpecific
  | (TypedSpecific & { type: `Element.${string}` })

export interface ElementSpecific extends TypedSpecificLike {
  children?: AnyElementSpecific[]
  props?: RecursionType<TypedSpecific>
  type: `Element.${string}`
}

@scope({
  type: 'Local',
  variables: [
    {
      get() {
        return this.getSelfExposedViewModel()
      },
      group: 'Element',
      name: 'self',
      type: 'Local'
    },
    {
      get() {
        return this.getExposedViewModel()
      },
      group: 'Element',
      name() {
        return this.id
      },
      type: 'Block'
    }
  ]
})
export class ElementNode extends TypedNode {
  @fromSpecific()
  @reactive('shallow')
  children: AnyElementNode[] = []

  @fromSpecific()
  @reactive()
  hidden: boolean | MustacheNode = false

  @fromSpecific()
  @reactive('deep')
  props: RecursionType<AnyTypedNode> = {}

  get plugin() {
    return this.getPlugin<ElementPlugin>()
  }

  override fromSnapshot(root: TypedNode): void {
    if (root instanceof TypedNode) {
      if (root.type === 'Page') {
        root.append(this, ['elements'])
      } else {
        root.append(this, ['children'])
      }
    }
  }

  override transpileSlave() {
    return this.render()
  }
}

declare global {
  export interface RehajeExtendsSpecifics {
    ExtendsElement: ElementSpecific
  }
}
